class FetchError extends Error {
    constructor(errorPayload, statusCode) {
        const message =
            typeof errorPayload === "string"
                ? errorPayload
                : errorPayload?.message || errorPayload?.detail || "Unknown error";

        super(message);

        this.statusCode = statusCode;
        this.payload = errorPayload;
    }

    json() {
        return {
            ...(typeof this.payload === "object"
                ? this.payload
                : {message: this.payload}),
            statusCode: this.statusCode,
        };
    }
}

export {FetchError};
